export enum PlanStartModesDisplay {
  Regular = 0,
  'Force Synthetic full backup' = 1,
  'Restart failed backup' = 2,
  'Differential backup' = 3,
  'Transaction log backup' = 4,
  'Force full backup' = 6
}

export enum PlanStartModesDisplayWithRun {
  Regular = 0,
  'Run Force Synthetic full backup' = 1,
  'Run Restart Failed backup' = 2,
  'Run Differential backup' = 3,
  'Run Transaction log backup' = 4,
  'Run force full backup' = 6
}

export enum AvailablePlanStartModes {
  Regular = 0,
  ForceSyntheticFull = 1,
  RestartFailed = 2,
  DiffBackup = 3,
  LogBackup = 4,
  ForceFull = 6
}
